<template>
  <el-dialog
    :visible.sync="dialogVisibleendFlag"
    :title="tasktitle"
    :before-close="closeAddTaskDialog"
    width="800px"
  >
    <el-form
      ref="formendtask"
      :model="formendtask"
      :rules="rules1"
      size="small"
      label-width="120px"
      style="height: 500px; overflow: auto"
    >
      <el-form-item label="任务标题" prop="task_name">
        <el-input
          v-model="formendtask.task_name"
          :disabled="tasktitle != '编辑任务'"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="任务描述">
        <el-input
          :autosize="{ minRows: 2 }"
          :disabled="tasktitle != '编辑任务'"
          v-model="formendtask.task_desc"
          type="textarea"
          show-word-limit
        />
      </el-form-item>

      <el-form-item label="负责人">
        <div style="width: 400px">
          <el-tag
            v-for="(item, index) in formendtask.executor"
            :key="index"
            style="margin-left: 5px"
            @close="handleClose2(item)"
            >{{ item.name }}({{ item.workcode }})</el-tag
          >
        </div>
      </el-form-item>

      <el-form-item label="截止日期" prop="planned_complete_time" class="fdg">
        <el-date-picker
          :picker-options="pickerOptions"
          :disabled="tasktitle != '编辑任务'"
          v-model="formendtask.planned_complete_time"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item>

      <el-form-item label="顾问" class="fdg" prop="consultant">
        <el-select
          v-model="formendtask.consultantname"
          :disabled="tasktitle != '编辑任务'"
          :remote-method="remoteMethod2"
          :loading="loading"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="请输入姓名"
          style="width: 80%"
        >
          <el-option
            v-for="(item, index) in useroptions2"
            :key="index"
            :label="item.label + '(' + item.value + ')'"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="担责人" class="fdg" prop="liability_user_id">
        <el-select
          v-model="formendtask.liabilityname"
          :disabled="tasktitle != '编辑任务'"
          :remote-method="remoteMethod4"
          :loading="loading"
          filterable
          remote
          clearable
          reserve-keyword
          placeholder="请输入姓名"
          style="width: 80%"
        >
          <el-option
            v-for="(item, index) in useroptions4"
            :key="index"
            :label="item.label + '(' + item.value + ')'"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="参与人" class="fdg">
        <el-select
          v-model="dlgname10"
          :disabled="tasktitle != '编辑任务'"
          :remote-method="remoteMethod10"
          :loading="loading"
          filterable
          remote
          reserve-keyword
          placeholder="请输入,支持多选"
          style="width: 80%"
          @change="changename10"
        >
          <el-option
            v-for="(item, index) in useroptions10"
            :key="index"
            :label="item.label + '(' + item.value + ')'"
            :value="item"
          />
        </el-select>
        <div style="height: 100px; overflow: auto; position: absolute">
          <el-tag
            v-for="(item, index) in username10"
            :key="index"
            closable
            style="margin-left: 5px"
            @close="handleClose10(item)"
            >{{ item.name }}({{ item.username }})</el-tag
          >
        </div>
      </el-form-item>

      <el-form-item label="知会人" class="fdg">
        <el-select
          v-model="dlgname12"
          :disabled="tasktitle != '编辑任务'"
          :remote-method="remoteMethod12"
          :loading="loading"
          filterable
          remote
          reserve-keyword
          placeholder="请输入,支持多选"
          style="width: 80%"
          @change="changename12"
        >
          <el-option
            v-for="(item, index) in useroptions12"
            :key="index"
            :label="item.label + '(' + item.value + ')'"
            :value="item"
          />
        </el-select>
        <div style="max-height: 80px; overflow: auto">
          <el-tag
            v-for="(item, index) in username12"
            :key="index"
            closable
            style="margin-left: 5px"
            @close="handleClose12(item)"
            >{{ item.name }}({{ item.username }})</el-tag
          >
        </div>
      </el-form-item>
      <!-- 编辑任务 交付件显示 -->
      <el-form-item v-if="tasktitle == '编辑任务'" label="交付件类型" required>
        <el-select
          v-model="formendtask.deliver_type_id"
          placeholder="请选择"
          style="width: 220px"
        >
          <el-option
            v-for="(item, index) in deliverTypeList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- 编辑任务 交付件显示 -->
      <br />
      <span v-if="tasktitle != '编辑任务'">
        <el-form-item label="是否已完成" class="fdg">
          <el-radio-group v-model="formendtask.is_complete">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 编辑任务显示交付件类型 -->
        <el-form-item label="交付件类型" required>
          <el-select
            v-model="formendtask.deliver_type_id"
            disabled
            placeholder="请选择"
            style="width: 220px"
          >
            <el-option
              v-for="(item, index) in deliverTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formendtask.is_complete == 1"
          label="交付件说明"
          required
        >
          <el-input
            :autosize="{ minRows: 2 }"
            v-model="formendtask.deliver_content"
            type="textarea"
          />
        </el-form-item>

        <el-form-item
          v-if="formendtask.is_complete == 1"
          label="实际完成时间"
          prop="complete_time"
          class="fdg"
        >
          <el-date-picker
            v-model="formendtask.complete_time"
            :picker-options="pickerOptions"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item
          v-if="formendtask.is_complete == 1"
          label="执行结果"
          prop="result_status"
          class="fdg"
        >
          <el-select v-model="formendtask.result_status" placeholder="请选择">
            <el-option :value="0" label="请选择" />
            <el-option :value="1" label="非常差" />
            <el-option :value="2" label="差" />
            <el-option :value="3" label="一般" />
            <el-option :value="4" label="好" />
            <el-option :value="5" label="非常好" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="formendtask.is_complete == 1"
          label="差异分析"
          prop="difference"
          class="fdg"
        >
          <el-input v-model="formendtask.difference" />
        </el-form-item>

        <el-form-item label="进度" prop="remark">
          <el-input
            :autosize="{ minRows: 2 }"
            v-model="formendtask.remark"
            type="textarea"
            placeholder="请输入内容"
          />
        </el-form-item>
        <!-- <el-form-item v-if="tasktitle!='编辑任务'" label="附件">
            <el-upload
              :file-list="taskfileList"
              :on-success="taskhandleChange"
              :headers="{Authorization:meeting.token}"
              :data="{upload_type:'attachment',file_type:'task',relate_id:formendtask.id}"
              class="upload-demo"
              :action="action"
              name="files">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div v-for="(item, index) in formendtask.attachments" :key="index" style="padding: 5px;">
              <a :href="item.href" :key="index" style="color: #409EFF;">{{ item.filename }}</a>
            </div>
          </el-form-item> -->
        <el-form-item label="附件">
          <el-upload
            :file-list="taskfileList"
            :on-success="taskhandleChange"
            :headers="{ Authorization: meeting.token }"
            :data="{
              upload_type: 'attachment',
              file_type: 'task',
              relate_id: formendtask.id,
            }"
            class="upload-demo"
            :action="action"
            name="files"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <div
            v-for="(item, index) in formendtask.attachments"
            :key="index"
            style="padding: 5px"
          >
            <a :href="item.href" :key="index" style="color: #409eff">{{
              item.filename
            }}</a>
            <span
              style="margin: 10px; font-size: 12px; color: red; cursor: pointer"
              @click="beforeRemove(item,index)"
              >删除</span
            >
          </div>
        </el-form-item>
        <!-- <el-timeline :reverse="false" style="margin: 10px 30px;">
            <el-timeline-item
              v-for="(activity, index) in formendtask.logList"
              :key="index"
              :timestamp="activity.add_time"
              placement="top"
              color="#0bbd87">
              {{ activity.creator_name }}：{{ activity.content }}
            </el-timeline-item>
          </el-timeline> -->

        <el-form-item label="执行情况">
          <el-timeline style="padding: 0px; line-height: 1.15">
            <el-timeline-item
              v-for="(itemHistory, index) in formendtask.history"
              :key="index"
              :timestamp="itemHistory.add_time"
              color="#0bbd87"
              placement="bottom"
            >
              {{
                itemHistory.creator_name +
                "(" +
                itemHistory.creator_workcode +
                ")" +
                "：" +
                itemHistory.content
              }}
            </el-timeline-item>
          </el-timeline>
        </el-form-item>
      </span>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeAddTaskDialog" size="small">取 消</el-button>
      <el-button
        v-if="tasktitle == '编辑任务' && is_complete == false"
        size="small"
        type="primary"
        @click="updatatask('formendtask')"
        >确 定
      </el-button>
      <el-button
        v-if="tasktitle == '更新进度' && is_complete == false"
        size="small"
        type="primary"
        @click="updatatask('formendtask')"
        >确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  taskedit,
  taskupdate,
  meetingtasks,
  deleteFile
} from '@/api/seedetails'
export default {
  data() {
    return {
      rules1: {
        result_status: [
          {
            required: true,
            message: '请输入执行结果',
            trigger: 'blur'
          }
        ],
        difference: [
          {
            required: true,
            message: '请输入差异分析',
            trigger: 'blur'
          }
        ],
        complete_time: [
          {
            required: true,
            message: '请选择完成时间',
            trigger: 'change'
          }
        ],
        remark: [
          {
            required: true,
            message: '请输入备注',
            trigger: 'blur'
          }
        ]
      },
      logList: [],
      meeting: {
        applicant: {},
        host: {},
        secretary: {},
        convenor: {},
        contact: {},
        room: {},
        address: {},
        token: this.$store.getters.token
      },
      taskfileList: [],
      username12: [],
      useroptions12: [],
      dlgname12: '', // zhihui人，仿负责人
      username10: [],
      useroptions10: [],
      useroptions4: [],
      useroptions2: [],
      loading: false,
      dlgname10: '',
      pickerOptions: {
        disabledDate: (time) => {
          // 设置可选择的日期为今天之后的一个月内
          // const curDate = new Date().getTime()
          // 这里算出一个月的毫秒数,
          // 这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          // const day = 10 * 24 * 3600 * 1000
          // const dateRegion = curDate + day
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      action: process.env.VUE_APP_BASE_API + '/common/upload'
    }
  },
  props: {
    dialogVisibleend: {
      type: Boolean,
      default: false
    },
    formendtask: {
      type: Object,
      default() {
        return {}
      }
    },
    is_complete: {
      type: Boolean,
      default: false
    },
    tasktitle: {
      type: String,
      default: ''
    },
    activeName2: {
      type: String,
      default: 'my'
    },
    page: {
      type: Number,
      default: 1
    },
    page_size: {
      type: Number,
      default: 10
    },
    deliverTypeList: {
      default() { return [] }
    }
  },
  computed: {
    dialogVisibleendFlag: {
      get() {
        return this.dialogVisibleend
      },
      set() {}
    }
  },
  methods: {
    closeAddTaskDialog() {
      this.$emit('closeEditTaskDialog', false)
    },
    taskhandleChange(responses, file, fileList) {
      this.taskfileList = []
      responses.data.attachment[0].href =
        process.env.VUE_APP_BASE_API +
        '/common/download/' +
        responses.data.attachment[0].id
      this.formendtask.attachments.push(responses.data.attachment[0])
    },
    handleClose2(tag) {
      this.formendtask.executor.splice(this.username.indexOf(tag), 1)
    },
    remoteMethod2(query) {
      console.log(this.formendtask.consultant)
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions2 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    remoteMethod4(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions4 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    changename10(val) {
      // 参会人
      const list = {}
      list.name = this.dlgname10.label
      list.username = this.dlgname10.value
      list.id = this.dlgname10.id

      let is = true
      if (this.username10.length > 0) {
        for (let index = 0; index < this.username10.length; index++) {
          const element = this.username10[index]
          if (list.username === element.username) {
            is = false
          }
        }
      } else {
        is = true
      }
      if (is) {
        this.username10.push(list)
      }
    },
    remoteMethod12(query) {
      // 知会人
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions12 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    remoteMethod10(query) {
      // 参与人
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions10 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    handleClose10(tag) {
      this.username10.splice(this.username10.indexOf(tag), 1)
    },
    changename12(val) {
      // 参会人
      const list = {}
      list.name = this.dlgname12.label
      list.username = this.dlgname12.value
      list.id = this.dlgname12.id

      let is = true
      if (this.username12.length > 0) {
        for (let index = 0; index < this.username12.length; index++) {
          const element = this.username12[index]
          if (list.username === element.username) {
            is = false
          }
        }
      } else {
        is = true
      }
      if (is) {
        this.username12.push(list)
      }
    },
    handleClose12(tag) {
      this.username12.splice(this.username12.indexOf(tag), 1)
    },
    gettaskTable(data1) {
      meetingtasks(data1)
        .then((response) => {
          if (data1.task_tab === 'all') {
            this.meetingtasklist = response
          }
          this.$parent.meetingtasklists = response.data.tasks || []
        })
        .catch((err) => {
          console.log(err)
        })
    },
    updatatask(formName) {
      const THis = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(THis.formendtask)

          console.log(typeof THis.formendtask.liabilityname)
          if (typeof THis.formendtask.liabilityname !== 'string') {
            THis.formendtask.liabilityname.user_id =
              THis.formendtask.liabilityname.id
            THis.formendtask.liabilityname.name =
              THis.formendtask.liabilityname.label
            THis.formendtask.liabilityname.workcode =
              THis.formendtask.liabilityname.value
          }

          if (typeof THis.formendtask.consultantname !== 'string') {
            THis.formendtask.consultantname.user_id =
              THis.formendtask.consultantname.id
            THis.formendtask.consultantname.name =
              THis.formendtask.consultantname.label
            THis.formendtask.consultantname.workcode =
              THis.formendtask.consultantname.value
          }
          // if (typeof THis.formendtask.notifyname !== 'string') {
          //   THis.formendtask.notifyname.user_id = THis.formendtask.notifyname.id
          //   THis.formendtask.notifyname.name = THis.formendtask.notifyname.label
          //   THis.formendtask.notifyname.workcode =
          //     THis.formendtask.notifyname.value
          // }

          // if (typeof THis.formendtask.leadername !== 'string') {
          //   THis.formendtask.leadername.user_id = THis.formendtask.leadername.id
          //   THis.formendtask.leadername.name = THis.formendtask.leadername.label
          //   THis.formendtask.leadername.workcode = THis.formendtask.leadername.value
          // }
          // 参会人处理
          const participant = []
          for (let index = 0; index < this.username10.length; index++) {
            const element = this.username10[index]
            const data10 = {
              name: element.name,
              workcode: element.username
            }
            participant.push(data10)
          }

          const notify = []
          for (let index = 0; index < this.username12.length; index++) {
            const element = this.username12[index]
            const data12 = {
              name: element.name,
              workcode: element.username
            }
            notify.push(data12)
          }

          const data = {
            task_name: THis.formendtask.task_name,
            liability:
              typeof THis.formendtask.liabilityname === 'string'
                ? THis.formendtask.liability
                : THis.formendtask.liabilityname,
            consultant:
              typeof THis.formendtask.consultantname === 'string'
                ? THis.formendtask.consultant
                : THis.formendtask.consultantname,
            // notify:
            //   typeof THis.formendtask.notifyname === 'string'
            //     ? THis.formendtask.notify
            //     : THis.formendtask.notifyname,
            // leader: typeof THis.formendtask.leadername === 'string' ? THis.formendtask.leader : THis.formendtask
            //   .leadername,
            executor: THis.formendtask.executor,
            planned_complete_time: THis.formendtask.planned_complete_time,
            complete_time: THis.formendtask.complete_time,
            is_complete: THis.formendtask.is_complete,
            result_status: THis.formendtask.result_status,
            difference: THis.formendtask.difference,
            remark: THis.formendtask.remark,
            attachments: THis.formendtask.attachments,
            meeting_id: this.$route.query.id,
            deliver_type_id: THis.formendtask.deliver_type_id,
            deliver_content: THis.formendtask.deliver_content,
            task_desc: THis.formendtask.task_desc,
            participant: participant,
            notify: notify
          }
          const id = THis.formendtask.id

          if (this.tasktitle === '编辑任务') {
            // 如果是编辑窗口调编辑接口，秘书，主持人，召集人用的
            taskedit(data, id)
              .then((response) => {
                const data1 = {
                  meeting_id: this.$route.query.id,
                  task_tab: this.activeName2,
                  page: this.page,
                  page_size: this.page_size
                }
                this.$message.success('编辑成功')
                this.gettaskTable(data1)
                setTimeout(() => {
                  this.closeAddTaskDialog()
                }, 1000)
              })
              .catch((err) => {
                console.log(err)
              })
          } else {
            // 如果是 更新 窗口调编辑接口 负责人用
            taskupdate(data, id)
              .then((response) => {
                const data1 = {
                  meeting_id: this.$route.query.id,
                  task_tab: this.activeName2,
                  page: this.page,
                  page_size: this.page_size
                }
                this.$message.success('更新成功')
                this.gettaskTable(data1)
                setTimeout(() => {
                  this.closeAddTaskDialog()
                }, 1000)
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    beforeRemove(file, index) {
      this.$confirm('此操作将删除 ' + file.filename + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteFile(file.id).then((res) => {
            if (res.code === 'success') {
              this.formendtask.attachments.splice(index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style>
</style>
